import { useTranslation } from '@packlink/translation-provider';
import { getIn, FastField } from 'formik';
import { getComposedFieldName } from '@packlink/utils';
import { FormField, SelectAutocomplete, Input } from '@shipengine/formik-giger';
import { useMemo } from 'react';
import DOMPurify from 'dompurify';
import { useCustomsFormContext, useCustomsFormData } from '../../../CustomsFormData.js';
import { Typography, FieldMessageType } from '@shipengine/giger';
import { jsxs, Fragment, jsx } from '@emotion/react/jsx-runtime';
import { OTHERS_CATEGORY, otherTariffNumberOption } from '../../../data/CustomsInvoiceItemTypes.js';
import { transformTariffNumberToAutocompleteOption } from '../../../data/dataTransformation.js';

const ENGLISH_LOCALE = 'en-GB';
function TariffNumberFields(_ref) {
  let {
    index
  } = _ref;
  const {
    t
  } = useTranslation();
  const {
    fieldNamePrefix,
    locale,
    tariffNumberLink,
    validTariffNumbers
  } = useCustomsFormContext();
  const {
    values,
    setFieldValue
  } = useCustomsFormData();

  // TODO: Improve this condition: https://packlink.atlassian.net/browse/PS-444
  const showEnglishInfo = locale !== ENGLISH_LOCALE;
  const getFieldName = field => getComposedFieldName(fieldNamePrefix, `inventoryOfContents[${index}]`, field);
  const getFieldData = field => getComposedFieldName(`inventoryOfContents[${index}]`, field);
  const categoryName = getFieldName('category');
  const categoryData = getFieldData('category');
  const categoryValue = getIn(values, categoryData);
  const tariffNumberName = getFieldName('tariffNumber');
  const isOtherCategory = (categoryValue === null || categoryValue === void 0 ? void 0 : categoryValue.value) === OTHERS_CATEGORY;
  const optionsTariffNumbers = useMemo(() => {
    const completeTariffNumbers = [...validTariffNumbers, otherTariffNumberOption];
    return completeTariffNumbers.map(item => transformTariffNumberToAutocompleteOption(item, t));
  }, [validTariffNumbers, t]);
  const handleCategoryChangeSideEffects = (_, option) => {
    var _option$value;
    const value = (_option$value = option === null || option === void 0 ? void 0 : option.value) !== null && _option$value !== void 0 ? _option$value : '';
    const cleanTariffNumberValue = value === OTHERS_CATEGORY ? '' : value !== null && value !== void 0 ? value : '';
    setFieldValue(tariffNumberName, cleanTariffNumberValue, true);
  };
  const tariffLink = useMemo(() => DOMPurify.sanitize(t('inventory-item.tariff-number.link', {
    link: tariffNumberLink
  }), {
    ADD_ATTR: ['target']
  }), [tariffNumberLink, t]);
  return jsxs(Fragment, {
    children: [jsxs(Typography, {
      component: "p",
      children: [t('inventory-item.category-description.info'), showEnglishInfo && jsx("strong", {
        children: t('inventory-item.description.english-info')
      })]
    }), jsx(FormField, {
      name: categoryName,
      children: jsx(FastField, {
        component: SelectAutocomplete,
        options: optionsTariffNumbers,
        label: t('inventory-item.label.select-category'),
        onChange: handleCategoryChangeSideEffects
      })
    }), isOtherCategory && jsxs("section", {
      children: [jsx("span", {
        children: t('inventory-item.tariff-number.info')
      }), jsx("p", {
        dangerouslySetInnerHTML: {
          __html: tariffLink
        }
      }), jsx(FormField, {
        name: tariffNumberName,
        message: {
          content: t('inventory-item.placeholder.tariff-number'),
          type: FieldMessageType.HINT
        },
        children: jsx(FastField, {
          component: Input,
          type: "number",
          label: t('inventory-item.label.tariff-number')
        })
      })]
    })]
  });
}

export { TariffNumberFields };
//# sourceMappingURL=TariffNumberFields.js.map
